import { useApi } from 'app/context';
import { useBasePaginatedList } from './useBasePaginatedList';
import { useCallback, useEffect } from 'react';
import { IDoctorSchema } from 'generated/axios';

interface Props {
  isActive?: boolean;
}

export const useDoctorList = ({ isActive }: Props) => {
  const { doctorsApi } = useApi();

  const {
    list,
    loading,
    setLoading,
    page,
    handlePageChange,
    pageSize,
    handlePageSizeChange,
    count,
    filter,
    handleFilter,
    handleSuccess,
    handleError,
  } = useBasePaginatedList<IDoctorSchema>();

  const get = useCallback(() => {
    setLoading(true);
    doctorsApi
      .webPaginateDoctors(page, pageSize, filter, isActive)
      .then((resp) => {
        if (resp.status >= 400) {
          return Promise.reject(resp);
        }
        handleSuccess(resp.data.results, resp.data.total);
      })
      .catch((err) => {
        handleError(err);
      })
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [doctorsApi, page, pageSize, filter]);

  useEffect(() => {
    get();
  }, [get]);

  const refresh = () => get();

  return {
    list,
    loading,
    page,
    handlePageChange,
    pageSize,
    handlePageSizeChange,
    count,
    filter,
    handleFilter,
    refresh,
  };
};
